import { CoreModel } from '../core/core.model';
export class ItemModel extends CoreModel {
/**
 * It is title for the Component.
 */
details?: boolean;
/**
 * Property for selectable
 */
selected?: boolean;
/**
 * Property for selectable
 */
selectable?: boolean;
/**
 * Property to show checkbox on list items
 */
withCheckbox?: boolean;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function ItemModel_tsickle_Closure_declarations() {
/**
 * It is title for the Component.
 * @type {?}
 */
ItemModel.prototype.details;
/**
 * Property for selectable
 * @type {?}
 */
ItemModel.prototype.selected;
/**
 * Property for selectable
 * @type {?}
 */
ItemModel.prototype.selectable;
/**
 * Property to show checkbox on list items
 * @type {?}
 */
ItemModel.prototype.withCheckbox;
}

